var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSteammaster(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_343_57137)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.64278 20.3986C8.38202 19.7775 8.09592 18.9122 7.97491 17.9072C7.73049 15.8773 8.15359 13.2586 10.8909 10.8861C12.967 9.08667 14.1375 6.97638 14.7889 5.32021C15.048 4.66131 15.2256 4.07267 15.3457 3.60151C15.6065 4.22258 15.8926 5.08785 16.0136 6.09291C16.258 8.12278 15.8349 10.7415 13.0976 13.114C11.0215 14.9134 9.85094 17.0237 9.19961 18.6799C8.94048 19.3388 8.76287 19.9274 8.64278 20.3986Z",
    stroke: "white",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.3806 21.5383C15.1994 21.9991 15.0659 22.4187 14.9685 22.7741C14.7768 22.2826 14.5833 21.6429 14.4956 20.9141C14.295 19.2488 14.6405 17.0999 16.8918 15.1486L16.6298 14.8464L16.8918 15.1486C18.6247 13.6467 19.6014 11.8856 20.1446 10.5043C20.3258 10.0435 20.4592 9.62389 20.5567 9.26851C20.7484 9.76003 20.9419 10.3998 21.0296 11.1285C21.2301 12.7939 20.8846 14.9428 18.6333 16.894L18.8953 17.1963L18.6333 16.894C16.9005 18.396 15.9238 20.157 15.3806 21.5383Z",
    stroke: "white",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.84935 13.4956C3.66814 13.9564 3.5347 14.376 3.43722 14.7314C3.24552 14.2399 3.05207 13.6001 2.96432 12.8713C2.7638 11.206 3.10929 9.05712 5.36059 7.1059L5.3606 7.1059C7.09349 5.60395 8.07013 3.84288 8.61336 2.46157C8.79457 2.00081 8.92801 1.58117 9.02549 1.22579C9.21718 1.71731 9.41062 2.35706 9.49837 3.08584C9.69889 4.75117 9.3534 6.90006 7.10212 8.85128L7.3641 9.15354L7.10211 8.85128C5.36922 10.3532 4.39258 12.1143 3.84935 13.4956Z",
    stroke: "white",
    strokeWidth: 0.8
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_343_57137"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSteammaster);
export default __webpack_public_path__ + "static/media/steammaster.7da919df71e9218861aa5e19aae2d037.svg";
export { ForwardRef as ReactComponent };